import React from 'react';
import { useStoreActions } from 'easy-peasy';
import styled from 'styled-components';

import SocialBar from '~/components/SocialBar';

import IWLogo from './Assets/iw-logo.svg';

const FooterWrapper = styled.div`
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
`;

const FooterLeftWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
`;

const AdditionalLink = styled.div`
  font-size: 12px;
  color: black;
  text-align: right;
  a,
  span {
    color: black;
    text-decoration: underline;
    cursor: pointer;
  }
`;

const Footer = () => {
  const setInfoboxContent = useStoreActions(
    (state) => state.info.setInfoboxContent
  );

  return (
    <FooterWrapper>
      <FooterLeftWrapper>
        <a rel="noopener noreferrer" target="_blank" href={config.logoLink}>
          <IWLogo width={42} height={26} />
        </a>
        <SocialBar />
      </FooterLeftWrapper>
      <div style={{ maxWidth: 400 }}>
        <AdditionalLink>
          Zur{' '}
          <a rel="noopener noreferrer" target="_blank" href={config.studyLink}>
            Studie
          </a>
        </AdditionalLink>
        <AdditionalLink>
          Definitionen und Hintergrundinformationen unter{' '}
          <span onClick={() => setInfoboxContent('faq')}>Info</span>
        </AdditionalLink>
      </div>
    </FooterWrapper>
  );
};

export default Footer;
